import React, { useState, createContext } from "react";
import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion";

const SwipeNavStyles = styled(motion.div)`
  display: grid;
  width: 100%;
  height: calc(100vh - 100px);
`;

export const DotContainer = styled.div`
  position: absolute;

  height: ${(props) =>
    props.styleprop && props.styleprop.height
      ? props.styleprop.height
      : "100px"};
  width: 20px;
  top: 45%;
  right: -2px;
  border-radius: 6px 0 0 6px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  z-index: 5;
`;

export const Dot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;

  position: relative;
  background: ${(props) => (props.innercolor ? props.innercolor : "#C1C1C1")};
`;

export const SizingContext = createContext({});

const SwipeNav = ({ Components }) => {
  const [currPage, setCurrPage] = useState(0);
  const [lockScroll, setLockScroll] = useState(false);

  console.log(Components);

  const Render = (pg, comps) => {
    // console.log(pg, "pg");
    let Component = () => (
      <motion.div
        transition={{ duration: 1, delay: 0.4 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        key={pg}
      >
        {comps[pg]}
      </motion.div>
    );

    return (
      <SizingContext.Provider
        value={{
          lockScroll,
          setLockScroll,
        }}
      >
        <Component />
      </SizingContext.Provider>
    );
  };

  //let It  = components[currComponent]

  const onSwipe = (direction) => {
    if (lockScroll) return;
    let len = Components.length - 1;
    if (direction === -1 && currPage === 0) return;
    if (direction === 1 && currPage === len) return;
    setCurrPage(currPage + direction);
  };

  return (
    <AnimatePresence>
      <SwipeNavStyles
        onDragEnd={(e, { offset }) => {
          //  if (lockScroll) return;

          if (offset.y >= 200) onSwipe(-1);
          if (offset.y <= -200) onSwipe(1);
        }}
        dragConstraints={{ bottom: 1, top: -1 }}
        drag="y"
      >
        {Render(currPage, Components)}
      </SwipeNavStyles>
      <DotContainer
        key={Math.random()}
        styleprop={{
          height: `${Components.length * 16.6}px`,
        }}
      >
        {Components.map((dt, index) => (
          <Dot
            onClick={() => setCurrPage(index)}
            key={Math.random()}
            // grey={greyDots.includes(location.pathname) ? "yes" : "no"}
            innercolor={index === currPage && "#46c8f5"}
          ></Dot>
        ))}
      </DotContainer>
    </AnimatePresence>
  );
};

export default SwipeNav;
